export enum BlueprintInstanceType {
	Axis = 'axis',
	Backsplash = 'backsplash',
	Backsplashes = 'backsplashes',
	Blueprint = 'blueprint',
	Breakpoint = 'breakpoint',
	Breakpoints = 'breakpoints',
	BlueprintMetadata = 'blueprint_metadata',
	Connection = 'connection',
	Connections = 'connections',
	Corner = 'corner',
	Corners = 'corners',
	Countertop = 'countertop',
	CountertopBreakpoint = 'countertop_breakpoint',
	CountertopMaterial = 'countertop_material',
	Dimension = 'dimension',
	Dimensions = 'dimensions',
	Island = 'island',
	Islands = 'islands',
	Item = 'item',
	Kitchen = 'kitchen',
	Kitchens = 'kitchens',
	KitchenDesign = 'kitchen_design',
	KitchenMaterial = 'kitchen_material',
	NoOp = 'no_op',
	Note = 'note',
	Notification = 'notification',
	Notifications = 'notifications',
	Notes = 'notes',
	Obstruction = 'obstruction',
	Obstructions = 'obstructions',
	Panel = 'panel',
	Panels = 'panels',
	PanelItem = 'panel_item',
	PanelItems = 'panel_items',
	PanelItemGroup = 'panel_item_group',
	PanelItemGroups = 'panel_item_groups',
	PanelTrim = 'panel_trim',
	PanelTrims = 'panel_trims',
	PanelBreakpoint = 'panel_breakpoint',
	Point = 'point',
	Position = 'position',
	PromotionalSku = 'promotional_sku',
	PromotionalSkus = 'promotional_skus',
	SkuAnnotation = 'sku_annotation',
	SkuAnnotations = 'sku_annotations',
	SurroundMaterial = 'surround_material'
}
